import type { RouteLocationNormalized } from 'vue-router'

import type { RouteAuthMeta } from '../types'

import { findRouteOrParentMatchingPredicate } from './findRouteOrParentMatchingPredicate'

/**
 * Returns whether a route (or its closest parent) is restricted by `meta.auth`.
 *
 * A route is restricted if it defines `meta.auth` with `mode` different from
 * `'public'`. A route with `auth: { mode: 'public' }` is explicitly public and
 * overrides a restricted parent. No `meta.auth` in the hierarchy = public.
 *
 * @example
 * if (isRouteRestricted(to)) { /* don't cache, enable tracking beacon, etc. *\/ }
 */
export function isRouteRestricted(route: RouteLocationNormalized): boolean {
  const matched = findRouteOrParentMatchingPredicate(route, (r) =>
    Boolean(r.meta?.auth),
  )

  const auth = matched?.meta?.auth as RouteAuthMeta | undefined
  return auth !== undefined && auth.mode !== 'public'
}
